import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNumericInput } from "../../utils/helpers"; 
const wpUrl = process.env.REACT_APP_WP_URL;

const Sidebar = ({ isSidebar, handleSidebar, event }) => {

    
     const [formData, setFormData] = useState({
        name: '',
        email: '',
        guests: '',
        contact_no: '',
        message: '',
      });

      const numberOnly = useNumericInput(formData, setFormData);
    
      const [status, setStatus] = useState(null); // 'loading', 'success', 'error'
      const [errorMessage, setErrorMessage] = useState('');
    
      // Update form state on input change
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
      };
    
      // Handle form submit
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        setStatus('loading');
        setErrorMessage('');
    
        // Basic validation example
        if (
          !formData.email ||
          !formData.name ||
          !formData.guests ||
          !formData.contact_no ||
          !formData.message
        ) {
          setErrorMessage('Please fill in all required fields.');
          setStatus('error');
          return;
        }
    
        const postData = {
          name: formData.name,
          email: formData.email,
          contact_no: formData.contact_no,
          guests: formData.guests,
          subject: `RSVP Events VIP Table Reservation from ${formData.name}`,
          message: `
            <html>
              <body>
                <h2>RSVPPASS VIP TABLE RESERVATION</h2>
                <p><strong>Event:</strong> ${event?.title?.rendered}</p>
                <p><strong>Date:</strong> ${event?.long_date}</p>
                <p><strong>Venue:</strong> ${event?.venue}</p>
                <p><strong>Name:</strong> ${formData.name}</p>
                <p><strong>Email:</strong> ${formData.email}</p>
                <p><strong>Contact No.:</strong> ${formData.contact_no}</p>
                <p><strong>No. of Guests:</strong> ${formData.guests}</p>
                <p><strong>Message:</strong></p>
                <p style="white-space: pre-line;">${formData.message}</p>
              </body>
            </html>
          `,
        };
    
    
        try {
          const response = await fetch(`${wpUrl}wp-json/myplugin/v1/send-vip-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData),
          });
    
          const data = await response.json();
    
          if (response.ok && data.success) {
            setStatus('success');
            setFormData({
              name: '',
              email: '',
              contact_no: '',
              guests: '',
              message: '',
            });
          } else {
            setErrorMessage(data.error || 'Failed to send message.');
            setStatus('error');
          }
        } catch (error) {
          setErrorMessage(error.message || 'Something went wrong.');
          setStatus('error');
        }
      };

    return (
        <div className={`xs-sidebar-group info-group info-sidebar ${isSidebar ? "isActive" : "close-sidebar"}`}>
            <div className="xs-overlay xs-bg-black" onClick={handleSidebar} />
            <div className="xs-sidebar-widget">
                <div className="sidebar-widget-container">
                    <div className="widget-heading">
                        <span className="close-side-widget" onClick={handleSidebar}>X</span>
                    </div>
                    <div className="sidebar-textwidget">
                        <div className="sidebar-info-contents">
                            <div className="content-inner">
                                <div className="logo">
                                    <Link to="/">
                                        {/* <img src={logo} alt="Logo" /> */}
                                    </Link>
                                </div>
                                <div className="content-box">
                                    <h4>Request Table</h4>
                                    {event && (
                                            <div>
                                            <p><strong>Event:</strong> {event.title?.rendered}</p>
                                            <p><strong>Date:</strong> {event.long_date}</p>
                                            <p><strong>Venue:</strong> {event.venue}</p>
                                            </div>
                                        )}
                                   
                                </div>
                                <div className="form-inner">
                                    <h4>Send us details</h4>
                                   <form className="contact-form-validated" noValidate onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name" required />
                                        </div>
                                        <div className="form-group">
                                            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" required />
                                        </div>
                                        <div className="form-group">
                                            <input type="text" name="contact_no" value={formData.contact_no} onChange={numberOnly} placeholder="Contact No." required />
                                        </div>
                                        <div className="form-group">
                                            <input type="text" name="guests" value={formData.guests} onChange={numberOnly} placeholder="Total Guests" required />
                                        </div>
                                        <div className="form-group">
                                            <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Notes..." />
                                        </div>
                                        <div className="form-group message-btn">
                                            <button type="submit" className="thm-btn" disabled={status === 'loading'}>
                                            {status === 'loading' ? 'Sending...' : 'Submit Now'}
                                            <span className="icon-arrow-right"></span>
                                            </button>
                                        </div>
                                        
                                        {status === 'error' && <p className="error-message">{errorMessage}</p>}
                                        {status === 'success' && <p className="success-message">Message sent successfully!</p>}
                                        </form>
                                    <div className="result" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
